import { createFileRoute } from '@tanstack/react-router';
import { Breadcrumbs } from '@components/navigation/Breadcrumb.tsx';
import SupplierLayout from '@components/layout/supplier/SupplierLayout.tsx';
import SupplierDeliveryWindowsPage from '@features/supplier/delivery-windows/SupplierDeliveryWindowsPage.tsx';
import { useSupplierDeliveryWindowsStore } from '@features/supplier/delivery-windows/supplierDeliveryWindowsStore.ts';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/s/$orgId/$portalId/delivery-windows')({
  component: RouteComponent,
  beforeLoad: () => {
    useSupplierDeliveryWindowsStore.getState().fetchDeliveryWindows();
  },
});

function RouteComponent() {
  const { t } = useTranslation('client');
  return (
    <SupplierLayout>
      <div className="mb-8">
        <Breadcrumbs items={[{ label: t('supplierDeliveryWindows.breadcrumb'), href: undefined }]} />
      </div>
      <SupplierDeliveryWindowsPage />
    </SupplierLayout>
  );
}
